import Axios from '../config/Axios';

export default function loadTreeView() {
  return Axios.get('/folder/list').then((oResponse) => oResponse.data);
}
